/**
 * Validation Rule Form Component
 */

import React from 'react';
import { Form, Input, InputNumber, Row, Col } from 'antd';

export const ValidationRuleForm: React.FC = () => {
  return (
    <>
      <Form.Item
        name="dogma_name"
        label="Validation Name"
        rules={[{ required: true, message: 'Please enter validation name' }]}
      >
        <Input placeholder="e.g., width_range_check" />
      </Form.Item>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="dogma_min"
            label="Minimum Value"
            dependencies={['dogma_max']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const max = getFieldValue('dogma_max');
                  if (value == null || max == null || value < max) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Minimum must be less than maximum'));
                },
              }),
            ]}
          >
            <InputNumber
              placeholder="Enter minimum value"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="dogma_max"
            label="Maximum Value"
            dependencies={['dogma_min']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const min = getFieldValue('dogma_min');
                  if (value == null || min == null || value > min) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Maximum must be greater than minimum'));
                },
              }),
            ]}
          >
            <InputNumber
              placeholder="Enter maximum value"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
